<template>
  <div>
    <div v-if="isActive" class="w-12 h-12 rounded-full bg-white flex items-center justify-center">
      <span class="text-green-500 font-bold text-2xl">0{{ stage }}</span>
    </div>
    <div
      v-else
      class="w-8 h-8 border-2 border-white/60 rounded-full flex items-center justify-center"
    >
      <div class="w-2 h-2 bg-white/60 rounded-full" />
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{ stage: '1' | '2' | '3' | '4'; isActive?: boolean }>();
</script>
